const getValue = data =>
  (data && typeof data === 'object')
    ? data.isInactive
      ? '-'
      : data.value ?? data.actualValue ?? data.comment
    : data;

export default getValue;